import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqSocialChannel');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'social_chat_rooms',
  type: 'post',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/board/reqSocialChannel.js